<template>
	<div class="knd-colofon">
		<div class="knd-paragraaf">
			<div class="colofon-title">{{ data.titel }}</div>
			<div v-html="data.tekst"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'App',
    props: ['data'],
	data() {
		return {
		}
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>


<style lang="scss">

.knd-colofon {
  text-align: center;
  background: var(--colofon-background);
  color: var(--colofon-color);

  .colofon-title {
    color: $jade;
    font-family: $font-header;
    font-size: 2.4em;
    font-weight: 100;
    margin-bottom: 0.5em; 
  }
}

</style>